/**
 * Subscription plan configuration.
 * Contains pricing information and plan details for Stripe integration.
 */

export interface Plan {
  id: string;
  name: string;
  priceId: string;
  interval: 'month' | 'quarter';
  price: number;
  currency: string;
  description: string;
  features: string[];
  popular?: boolean;
}

export const SUBSCRIPTION_PLANS: Plan[] = [
  {
    id: 'monthly',
    name: 'Monthly Plan',
    priceId: import.meta.env.VITE_PRICE_ID_MONTHLY ?? 'price_1S7oTlB2BcKqzfFuZye86Z84',
    interval: 'month',
    price: 26.99,
    currency: 'USD',
    description: 'Perfect for getting started',
    features: [
      'Unlimited conversations',
      'Advanced AI companions',
      'Priority support',
      'All premium features',
    ],
  },
  {
    id: 'quarterly',
    name: 'Quarterly Plan',
    priceId: import.meta.env.VITE_PRICE_ID_QUARTERLY ?? 'price_1SDX1VB2BcKqzfFuqdb2lOUu',
    interval: 'quarter',
    price: 36.99,
    currency: 'USD',
    description: 'Best value for regular users',
    features: [
      'Unlimited conversations',
      'Advanced AI companions',
      'Priority support',
      'All premium features',
      'Save 54% compared to monthly',
    ],
    popular: true,
  },
];

export const getPlanById = (id: string): Plan | undefined => {
  return SUBSCRIPTION_PLANS.find((plan) => plan.id === id);
};

export const getPlanByPriceId = (priceId: string): Plan | undefined => {
  return SUBSCRIPTION_PLANS.find((plan) => plan.priceId === priceId);
};
